<button (click)="onClickExport()" class="form-control btn input-group-text" type="button">
  <i class="ft-download"></i>
</button>
